import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CompanyProfileService } from 'app/shared/services/company-profile.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { DomSanitizer} from '@angular/platform-browser';
import { NbThemeService } from '@nebular/theme';


@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

  isDark: boolean = false;

  showProcessingIndicatorLogo =false;
  showProcessingIndicatorSignature =false;
  showProcessingIndicatorDefaultCompany =false;
  logoForm: FormGroup;
  imageUrlLogo :any ="/assets/images/default-logo.png"
  selectedLogo : File = null;

  signatureForm: FormGroup;
  imageUrlSignature :any ="/assets/images/defaultSignature.jpg"
  selectedSignature : File = null;

  companyList = [];
  defaultCompany : string = null;
  companyData : any;
 
 
  constructor(private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private companyProfileService: CompanyProfileService,
    private domSanitizer: DomSanitizer,
    private themeService: NbThemeService,
   ) { }

  ngOnInit(): void {
    this.companyData  = {
      defaultCompany: null
    }

    this.initLogoForm();
    this.getAllCompanies();


      
      this.themeService.onThemeChange()
      .subscribe(themeName =>{
           this.isDark  = themeName.name ==='dark' ? true : false;
          });

  }

  getAllCompanies(){
    this.companyProfileService.getAll()
     .subscribe(
        (data) => {
                  this.companyList = data; 
                  this.loadLogo(); 
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                 });  
       
     }

  initLogoForm(){
    this.logoForm = this.fb.group({
      logo : [null],
    });
    this.signatureForm = this.fb.group({
      signature : [null],
    });
  }

  onLogoSelected(event){
    this.selectedLogo = <File> event.target.files[0];
    //show image 
    var reader = new FileReader();
    reader.onload = (event : any)=>{
      this.imageUrlLogo = event.target.result;
    }
    reader.readAsDataURL(this.selectedLogo);
  }

  onSignatureSelected(event){
    this.selectedSignature = <File> event.target.files[0];
    //show image 
    var reader = new FileReader();
    reader.onload = (event : any)=>{
      this.imageUrlSignature = event.target.result;
    }
    reader.readAsDataURL(this.selectedSignature);
  }

  saveLogoButtonClick(): void {
    var data :any;
  
            const formData  = new FormData();       
        
            if(this.selectedLogo){
              formData.append('logo', this.selectedLogo, this.selectedLogo.name);
            }
            else{
              formData.append('logo', null);
            }      
           
                this.showProcessingIndicatorLogo = true;
                this.companyProfileService.updateLogo(formData)
                .subscribe(
                  (res) => {
                              data=res;
                              this.toastr.success('Logo added successfully','Success');     
                              this.showProcessingIndicatorLogo  = false;  
                              console.log(res);  
                            },        
                  (err) =>  {
                              this.toastr.error('Failed to add record','Failure');                            
                              this.showProcessingIndicatorLogo = false;
                              console.log(err);
                            }, 
                  )               
                       
         
      }

   saveSignatureButtonClick(){
    var data :any;
  
      const formData  = new FormData();       
  
      if(this.selectedSignature){
        formData.append('signature', this.selectedSignature, this.selectedSignature.name);
      }
      else{
        formData.append('signature', null);
      }      
     
          this.showProcessingIndicatorSignature = true;
          this.companyProfileService.updateSignature(formData)
          .subscribe(
            (res) => {
                        data=res;
                        this.toastr.success('Signature added successfully','Success');     
                        this.showProcessingIndicatorSignature = false;  
                        console.log(res);  
                      },        
            (err) =>  {
                        this.toastr.error('Failed to add record','Failure');                            
                        this.showProcessingIndicatorSignature = false;
                        console.log(err);
                      }, 
            )               
     
     
                        
   }

  

loadLogo(){

  if(this.companyList[0].Logo){
    let TYPED_ARRAY = new Uint8Array(this.companyList[0].Logo.data);
    const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
      return data + String.fromCharCode(byte);
    },'');
    let base64String = btoa(STRING_CHAR);
    this.imageUrlLogo = this.domSanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + base64String);
   }else{
     this.imageUrlLogo ="/assets/images/default-logo.png";
   }


   
  if(this.companyList[0].DigitalSignature){
    let TYPED_ARRAY = new Uint8Array(this.companyList[0].DigitalSignature.data);
    const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
      return data + String.fromCharCode(byte);
    },'');
    let base64String = btoa(STRING_CHAR);
    this.imageUrlSignature = this.domSanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + base64String);
   }else{
    this.imageUrlSignature ="/assets/images/defaultSignature.jpg";
   }
}



}
